import { render, staticRenderFns } from "./ListaHabilidade.vue?vue&type=template&id=4443fc35"
import script from "./ListaHabilidade.vue?vue&type=script&lang=js"
export * from "./ListaHabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports